var _g, _path, _g2, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgEligibilitySubscription = function SvgEligibilitySubscription(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 108,
    viewBox: "0 0 96 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_11406_117303)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.8216 60.4767C47.3961 60.1776 48.0797 60.1753 48.6562 60.4703L75.5213 74.2196C76.973 74.9626 76.973 77.0374 75.5213 77.7804L48.6562 91.5297C48.0797 91.8247 47.3961 91.8224 46.8216 91.5233L20.4081 77.774C18.9727 77.0269 18.9727 74.9731 20.4081 74.226L46.8216 60.4767Z",
    fill: "black",
    fillOpacity: 0.01
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11406_117303",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 12,
    width: 63,
    height: 72
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.1769 13.1547C47.4145 12.4402 48.9393 12.4402 50.1769 13.1547L77.3538 28.8453C78.5914 29.5598 79.3538 30.8803 79.3538 32.3094V63.6906C79.3538 65.1197 78.5914 66.4402 77.3538 67.1547L50.1769 82.8453C48.9393 83.5598 47.4145 83.5598 46.1769 82.8453L19.0008 67.1547C17.7633 66.4402 17.0009 65.1197 17.0008 63.6907L17.0001 32.3095C17 30.8804 17.7624 29.5598 19.0001 28.8453L46.1769 13.1547Z",
    fill: "#C4C4C4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11406_117303)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    transform: "matrix(0.866025 0.5 -0.866025 0.5 48.2141 12)",
    fill: "url(#paint0_linear_11406_117303)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -2.98023e-8,
    y: 0.5,
    width: 35,
    height: 35,
    transform: "matrix(0.866025 0.5 -0.866025 0.5 48.6471 12.25)",
    stroke: "white",
    strokeOpacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    transform: "matrix(0.866025 -0.5 2.20305e-08 1 48.2141 48)",
    fill: "url(#paint1_linear_11406_117303)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.433013,
    y: 0.25,
    width: 35,
    height: 35,
    transform: "matrix(0.866025 -0.5 2.20305e-08 1 48.2721 48.2165)",
    stroke: "white",
    strokeOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.656 51.8887L58.6831 54.1824C58.5541 54.2569 58.4305 54.3874 58.3393 54.5454C58.2481 54.7033 58.1969 54.8756 58.1969 55.0245L58.1969 59.6116C58.1969 59.6854 58.2094 59.7514 58.2338 59.8055C58.2582 59.8594 58.294 59.9007 58.3391 59.9268L64.6596 63.5759C64.7048 63.602 64.7585 63.6125 64.8175 63.6067C64.8765 63.6009 64.9397 63.5789 65.0036 63.542C65.0675 63.5051 65.1307 63.4541 65.1898 63.3918C65.2488 63.3295 65.3024 63.2571 65.3475 63.1789L69.3201 56.2974C69.4113 56.1395 69.4625 55.9672 69.4625 55.8183C69.4625 55.6694 69.4113 55.5562 69.3201 55.5036L62.9994 51.8551C62.9084 51.8024 62.7849 51.8145 62.656 51.8887Z",
    fill: "url(#paint2_linear_11406_117303)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.0134 55.4844C61.2749 55.3334 61.487 55.4558 61.487 55.7578C61.487 56.0598 61.2749 56.4271 61.0134 56.5781C60.7518 56.7291 60.5397 56.6067 60.5397 56.3047C60.5397 56.0027 60.7518 55.6354 61.0134 55.4844ZM61.9606 55.4844C61.9606 54.8803 61.5365 54.6355 61.0134 54.9375C60.4902 55.2395 60.0661 55.9741 60.0661 56.5781C60.0661 57.1822 60.4902 57.427 61.0134 57.125C61.5365 56.823 61.9606 56.0884 61.9606 55.4844Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.1693 51.0949C59.1693 50.7848 59.387 50.4078 59.6555 50.2527L64.1149 47.6781C64.5015 47.455 64.8723 47.4182 65.1457 47.5759L71.668 51.3415C71.8578 51.4511 71.8578 51.8066 71.668 52.1355C71.4781 52.4643 71.1703 52.6421 70.9804 52.5324L64.4584 48.7669C64.4583 48.7669 64.4584 48.767 64.4584 48.7669C64.3672 48.7145 64.2436 48.7267 64.1149 48.8009C64.1148 48.801 64.1149 48.8009 64.1149 48.8009L59.6555 51.3756C59.387 51.5306 59.1693 51.4049 59.1693 51.0949Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.6517 54.1485C57.9252 53.6747 58.2962 53.2831 58.6831 53.0597L62.6563 50.7658L62.6563 51.3272L62.6567 50.7656C63.0434 50.5427 63.4141 50.5064 63.6874 50.6645L70.0077 54.3128C70.2811 54.4708 70.4348 54.8104 70.4348 55.257C70.4348 55.7036 70.2812 56.2206 70.0078 56.6943L66.0353 63.5756C65.8998 63.8103 65.739 64.0273 65.562 64.2143C65.385 64.4012 65.1952 64.5543 65.0036 64.6649C64.812 64.7756 64.6222 64.8415 64.4452 64.859C64.2682 64.8765 64.1073 64.8452 63.9719 64.7669L57.6515 61.1178C57.5161 61.0395 57.4085 60.9157 57.3353 60.7536C57.2621 60.5916 57.2244 60.3943 57.2245 60.1732L57.2245 55.5861C57.2245 55.1394 57.3782 54.6223 57.6517 54.1485ZM62.656 51.8888L58.6831 54.1826C58.5541 54.257 58.4305 54.3876 58.3393 54.5455C58.2481 54.7034 58.1969 54.8758 58.1969 55.0247L58.1969 59.6118C58.1968 59.6855 58.2094 59.7515 58.2338 59.8056C58.2582 59.8596 58.294 59.9008 58.3391 59.9269C58.3391 59.9269 58.339 59.9269 58.3391 59.9269L64.6596 63.5761C64.7047 63.6022 64.7585 63.6127 64.8175 63.6068C64.8765 63.601 64.9397 63.579 65.0036 63.5421C65.0675 63.5053 65.1307 63.4542 65.1897 63.3919C65.2487 63.3296 65.3023 63.2573 65.3475 63.179L69.3201 56.2975C69.4112 56.1396 69.4624 55.9673 69.4624 55.8184C69.4624 55.6696 69.4112 55.5564 69.3201 55.5037L62.9994 51.8552C62.9084 51.8025 62.7848 51.8146 62.656 51.8888Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    transform: "matrix(0.866025 0.5 -2.20305e-08 1 17.0378 30)",
    fill: "url(#paint3_linear_11406_117303)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.433013,
    y: 0.75,
    width: 35,
    height: 35,
    transform: "matrix(0.866025 0.5 -2.20305e-08 1 17.0959 29.7835)",
    stroke: "white",
    strokeOpacity: 0.4
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6769 14.0207C47.6051 13.4848 48.7487 13.4848 49.6769 14.0207L76.8538 29.7113C77.782 30.2472 78.3538 31.2376 78.3538 32.3094V63.6906C78.3538 64.7624 77.782 65.7528 76.8538 66.2887L49.6769 81.9793C48.7487 82.5152 47.6051 82.5152 46.6769 81.9792L19.5008 66.2887C18.5727 65.7528 18.0009 64.7624 18.0008 63.6907L18.0001 32.3094C18 31.2376 18.5718 30.2472 19.5001 29.7113L46.6769 14.0207Z",
    stroke: "white",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_11406_117303",
    x: 3.33154,
    y: 44.2507,
    width: 89.2786,
    height: 63.4985,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.188235 0 0 0 0 0.843137 0 0 0 0 0.533333 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11406_117303"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_11406_117303",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11406_117303",
    x1: -0.267884,
    y1: 0.267885,
    x2: 35.7321,
    y2: 0.267886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87E8BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#32D789"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_11406_117303",
    x1: -0.535769,
    y1: -0.267884,
    x2: 36.8338,
    y2: -0.136971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30D788"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A8955"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_11406_117303",
    x1: 70.4349,
    y1: 60.4027,
    x2: 58.4922,
    y2: 53.9192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_11406_117303",
    x1: 17.2767,
    y1: -10.1384,
    x2: 43.4682,
    y2: -1.59252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30D788"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A8955"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEligibilitySubscription);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "eligibility_subscription.4837ddc3fe6cb9b1b804b8f139245357.svg";